module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2-left"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Two")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("E")]), _vm._v("veryone is going to die.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("You could wake up, get out of bed, trip over a pair of sneakers on the way to the bathroom, fall down the stairs, and break your neck. You could get some crazy disease. You could cross the street and get hit by a car. You could have a brain aneurysm, or maybe choke on a piece of hot dog like Jimmy Trevino did during lunch freshman year. While most of us were standing there with our mouths open, thinking, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Do something!")]), _vm._v(" Miles crashed through the tables and chairs, grabbed Jimmy around the middle, and jammed his fists up under Jimmy’s rib cage until the small piece of meat shot out of Jimmy’s mouth. Jimmy lived, but another minute and he could have been brain-dead, ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("which is pretty much like being dead, or he could have been dead-dead.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The point is you die. Most of the time you don’t see it coming.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I used to cover my head with a black hoodie thinking it’d help me be invisible. But a seventeen-year-old male walking the streets alone in a hoodie automatically invites suspicion. I swear it’s why I was questioned once by an officer. I gave him some story about how I was on my way home, and he let me off with a warning. Sometimes I wear a baseball cap. The front hangs over my face like a duck’s bill, casting a shadow I try to hide in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tonight’s been uneventful. I walked underneath the bridge where the LA river trickles into the cement arroyo, steering clear of the narrow path that curves up alongside the back part of the bridge. I made the mistake of going that way a couple of months ago and ran into a homeless man and his knife. To be fair, it was the middle of the night and I probably scared the guy. I didn’t stick around to find out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I step onto the bridge, it narrows in front of me like a tunnel. The usual dizziness comes, what I guess is vertigo, along with the bile. I resist the urge to throw up. Taking deep breaths, I close my eyes and practice one of Chris’s meditation techniques that has actually proved useful. I simply relax and don’t stop any image or thought from entering my mind.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("I’m back in the car. Grace is next to me. She’s singing along to the radio, like she always does. Her voice is a deep alto. We’re going . . . where are we going again? The movies? I can’t remember.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The tall lampposts, each lit with five small globes, string along the bridge like Christmas lights. I’m laughing. Then it’s as if there’s an explosion and there’s light everywhere, like I’m inside of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mark,” Grace says right before the music of screeching tires and scraping metal. Which is followed by the sounds of our car flipping and rolling. The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("crack")]), _vm._v(" of bone breaking and glass shattering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My head hits a window. I’m hanging upside down, the seat belt cutting into my chest. And Grace—Grace is next to me. Her eyes are open, and she’s holding her breath. It is so quiet. I’m waiting, waiting to hear her breathe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The image fades, and I keep moving forward on the bridge. I can’t believe it’s the last week of summer vacation. How did that happen? It’s not like I’m dreading school, it’s more like I’ve lost track of time. Or maybe time has lost track of me.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Cars occasionally drive by, but I’m mostly alone. I stop in the middle of the bridge, where a square concrete slab acts as a bench. I stand on it and reach up to touch the top of the black iron spikes of the suicide bars. I push down, but they’re ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("not sharp enough to pierce the skin. Even though I’m not super tall, 5'10\", I easily scale the rail and climb over.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other side, I hold the bars and lean forward, like I’m a skier who has jumped and now flies through the air. The water rushes below. It’s dark, but the light from the bridge and the surrounding buildings is enough to let me see the concrete below. If I hurl myself forward with enough velocity, maybe I can reach the trees in the arroyo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It happened in the 1930s. Some distraught mom wrapped her baby girl in a blanket, kissed her, and threw her off the bridge before jumping after her. The mom died, but the girl was caught in the branches of a tree. She lived. I would have liked to have seen that. I picture the white blanket unraveling, trailing after her like white smoke, snagging in the tree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stretch my body out farther, though I hold tight to the rails.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Grace!” I yell into the darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one answers back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I try again. “Grace!” Not even an echo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It should have been me,” I whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I close my eyes and see her again, that blank stare. The guilt overwhelms me, and I wish I were the dead one. Really, it would be so easy.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("I try to feel it, that space between wanting to live and wanting to die, as if it’s tangible, someplace I can crawl into. I ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("strain against the bridge and the air. Only my fingertips hold my weight.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The steel bar cuts into my fingers. My arms start to shake. I open my eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Someday I will die, but not today. I climb over the bars and make my way back to the side road where I parked the car.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a756f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 66
// module chunks = 0